import { buildProps } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'
import type FlexSplitLayout from './flex-split-layout.vue'

export const dragSpeed = ['slow', 'medium', 'quick'] as const

// 定义组件props
export const flexSplitLayoutProps = buildProps({
  // 左侧默认宽度
  leftDefaultWidth: {
    type: Number,
    default: 40,
  },
  // 左侧当前宽度
  leftCurrentWidth: {
    type: Number,
    default: 0,
  },
  // 左侧最小宽度
  leftMinWidth: {
    type: Number,
    default: 80,
  },
  // 左侧最大宽度
  leftMaxWidth: {
    type: Number,
    default: 20,
  },
  // 右侧最小宽度
  rightMinWidth: {
    type: Number,
    default: 40,
  },
  // 是否显示按钮
  isShowBtn: {
    type: Boolean,
    default: true,
  },
  // 是否开启拖拽
  drag: {
    type: Boolean,
    default: true,
  },
  // 折叠
  fold: {
    type: Boolean,
    default: true,
  },
  // 折叠状态
  foldState: {
    type: Boolean,
    default: false,
  },
  // 分割线颜色
  dividerColor: {
    type: String,
    default: 'var(--color-split)',
  },
  // 动画速度
  speed: {
    type: String,
    values: dragSpeed,
    default: '',
  },
  // 是否弹性布局
  flex: {
    type: Boolean,
    default: false,
  },
} as const)

// props
export type FlexSplitLayoutProps = ExtractPropTypes<typeof flexSplitLayoutProps>

// instance
export type FlexSplitLayoutInstance = InstanceType<typeof FlexSplitLayout>
